(() => {
    if (consentsCookieData.userHasSetCookies) return;

    Vendallion.PopupModal({
        moveContent: "#cookieconsent-form",
        modalClass: "cookies-popup",
        onOpen: function (popupModal) {
            popupModal.querySelector("button.close").style.display = "none";
            initCookiesPopup();
        },
        onClose: function () {},
    });

    function initCookiesPopup() {
        const cookiesForm = document.querySelector("#cookie-consent-form");

        const manageCookiesButton = cookiesForm.querySelector("#manage-cookie-preferences");
        const introText = cookiesForm.querySelector(".js-intro-text");
        const savePrefButton = cookiesForm.querySelector("#save-cookie-preferences");
        const acceptButton = cookiesForm.querySelector("#accept-all-cookies");
        const declineButton = cookiesForm.querySelector("#decline-cookie-preferences");
        const actions = cookiesForm.querySelector(".js-cookie-consent-actions");

        manageCookiesButton.addEventListener("click", (e) => {
            const cookiesOptionContainer = cookiesForm.querySelector(".cookie-consent-options");
            cookiesOptionContainer.classList.remove("hidden");
            introText.classList.add("hidden");
            savePrefButton.classList.remove("hidden");
            manageCookiesButton.classList.add("hidden");
            actions.classList.add("cookies-shadow");
        });
    }
})();
